import React, { useCallback, useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import PersonalInformationTab from "../personalInformationTab/personalInformationTab";
import SubscriptionDetailsTab from "../SubscriptionDetailsTab/SubscriptionDetailsTab";
import OrdersTab from "../OrdersTab/OrdersTab";
import SettingsTab from "../SettingsTab/SettingsTab";
import { CarouselPriceMobile } from "features/payment/components/CarouselPriceMobile";
import { fetchRequest } from "utils/restApiCleintAxios";
import { ProgramItems } from "types/landing";
import "screens/PaymentScreen/styles.scss";
import "features/payment/components/PriceList/styles.scss";
import { useQuery } from "hooks/useQuery";
import { localStorageKeys } from "config/localStorageKeys";
import { placeOrderFunc } from "store/users/thunkActions";
import { useTypedDispatch } from "store";
interface Props {
  onSelect?: (k: string) => void;
  dataOrders?: any[];
}

const ProfileTabs = ({ onSelect, dataOrders }: Props) => {
  const queryData = useQuery();

  const dispatch = useTypedDispatch();

  const [activeTab, setActiveTab] = useState(queryData.get("tab") || "home");

  const [data, setData] = useState<ProgramItems[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await fetchRequest("api/content/DynamicContent/?lang=he", {
        method: "get"
      });
      if (res.data?.result?.programItems && res.data?.result?.programItems?.length) {
        setData(res.data?.result?.programItems?.splice(1, 10));
      }
    };
    fetchData();
  }, []);

  const onBuy = useCallback(
    async (val: ProgramItems) => {
      try {
        const infoRequest: any = await dispatch(placeOrderFunc(val));

        if (infoRequest?.data?.orderInfo) {
          localStorage.setItem(localStorageKeys.orderPlanInfo, JSON.stringify(infoRequest.data));
        }
        if (infoRequest?.data?.paymentPage) {
          localStorage.removeItem(localStorageKeys.choosePrice);
          window.open(infoRequest?.data?.paymentPage, "_blank");
        }
      } catch {
        //
      }
    },
    [dispatch]
  );

  return (
    <div className="tab-courses-mobile">
      <Tabs
        defaultActiveKey="bidding"
        className="mb-3"
        activeKey={activeTab}
        onSelect={(k: string) => {
          setActiveTab(k);
          onSelect && onSelect(k);
        }}>
        <Tab eventKey="home" title="פרטים אישיים" key="home">
          <PersonalInformationTab />
        </Tab>
        <Tab eventKey="profile" title="פרטי המנוי" key="profile">
          <SubscriptionDetailsTab />
        </Tab>
        <Tab eventKey="Orders" title="הזמנות" key="Orders">
          <OrdersTab data={dataOrders} />
        </Tab>
        <Tab eventKey="Plans" title="רכישת מנוי" key="Plans">
          <div className="payment-screen-wrapper-mobile">
            <div className="wrapper-tap-pricing">
              <CarouselPriceMobile data={data} onBuy={onBuy} />
            </div>
          </div>
        </Tab>
        <Tab eventKey="Settings" title="הגדרות" key="Settings">
          <SettingsTab />
        </Tab>
      </Tabs>
    </div>
  );
};

export default ProfileTabs;
